import { IContact } from "../types/contacts";
import { IMessage, ISession } from "../types/message";
import { apiCore, ApiResponse } from "./apiCore";
import * as url from "./urls";

/* ============================================================
   🌐 Endpoints
   ============================================================ */

// GET - sessions Active
export const getSessionsActive = async (): Promise<ISession[]> => {
  const response = await apiCore<ISession[]>(`${url.SESSION}`, {
    method: "GET",
  });

  if (response.status === 204) {
    return [];
  }

  return response.data;
};

// GET - mensagens de um contato
export const getMessages = async (id: number): Promise<IMessage> => {
  const response = await apiCore<IMessage>(`${url.MESSAGES}/${id}`, {
    method: "GET",
  });
  return response.data;
};

// GET - mensagens para layout CONTACT
export const getMessagesContact = async (id: number): Promise<IMessage[]> => {
  const response = await apiCore<IMessage[]>(`${url.MESSAGES}/${id}`, {
    method: "GET",
  });
  return response.data;
};

// GET - mensagens do usuário logado
export const getMessagesUser = async (id: number): Promise<IMessage[]> => {
  const response = await apiCore<IMessage[]>(`${url.MESSAGES}/${id}/User`, {
    method: "GET",
  });
  return response.data;
};

// POST - enviar mensagem
export const sendMessage = async (data: object): Promise<IMessage> => {
  const response = await apiCore<IMessage>(`${url.MESSAGES}`, {
    method: "POST",
    body: data,
  });
  return response.data;
};

// PUT - marcar como lida
export const readConversation = async (
  contactId: number,
  userId: number
): Promise<boolean> => {
  const response = await apiCore<boolean>(
    `${url.READ_CONVERSATION}/${contactId}/user/${userId}/read`,
    {
      method: "PUT",
    }
  );
  return response.data;
};

// GET - polling / novas mensagens
export const messageContactsNoAssigned = async (
  enterpriseId: number
): Promise<IContact[]> => {
  console.log(
    "[messages] messageContactsNoAssigned - enterpriseId:",
    enterpriseId
  );
  const response = await apiCore<IContact[]>(
    `${url.RECEIVE_MESSAGE}/${enterpriseId}/ContactsNoAssigned`,
    {
      method: "GET",
    }
  );
  return response.data;
};

// // DELETE - apagar mensagem única
// export const deleteMessage = (id: number | string) =>
//   apiCore(`${url.MESSAGES}/${id}`, { method: "DELETE" });

// // POST - encaminhar
// export const forwardMessage = (data: object) =>
//   apiCore(url.FORWARD_MESSAGE, { method: "POST", body: data });

// // DELETE - apagar todas mensagens de um contato
// export const deleteUserMessages = (contactId: number | string) =>
//   apiCore(`${url.DELETE_USER_MESSAGES}/${contactId}`, { method: "DELETE" });

// // DELETE - deletar imagem da mensagem
// export const deleteImage = (
//   userId: number,
//   messageId: number,
//   imageId: number
// ) =>
//   apiCore(`${url.DELETE_IMAGE}/${userId}/${messageId}/${imageId}`, {
//     method: "DELETE",
//   });
